import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { NgbActiveModal } from '@cmps/ng-bootstrap';
import { timer } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { CommitmentKpi, GoalStatus } from '../../coaching-base/general';
import { SortDirection } from '../../coaching-insight/oa/models/sorting.model';
import { TranslationKeyMap } from '../coaching-commitment.i18n';
import { GoalFormValue } from '../commitment-goals/goals.commitment.form';
import { CommitmentGoalHistory } from '../models/commitment-goal-history.model';

import { goalHistoryMap } from './history.goal.commitment.function';

@Component({
    selector: 'cmps-goal-history-commitment',
    templateUrl: './history.goal.commitment.component.html',
    host: {
        class: 'cmps-goal-history-commitment',
        '[class.cmps-goalhistorydialog-modal--start]': '_transitionSelfStart',
        '[class.cmps-goalhistorydialog-modal--show]': '_transitionSelfShow',
    },
})
export class GoalHistoryCommitmentComponent implements OnChanges, OnInit {
    @Input() goal: GoalFormValue;
    @Input() history: CommitmentGoalHistory[];

    @Output() onChangeSelectedGoal: EventEmitter<CommitmentKpi>;
    @Output() onSort: EventEmitter<SortDirection>;

    /** @private */ _dataSource: CommitmentGoalHistory[];

    /** @private */ _transitionSelfStart: boolean;
    /** @private */ _transitionSelfShow: boolean;
    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _GoalStatus = GoalStatus;

    constructor(
        private readonly _el: ElementRef<HTMLElement>,
        /** @private */ readonly _activeModal: NgbActiveModal,
    ) {
        this.onChangeSelectedGoal = new EventEmitter();
        this.onSort = new EventEmitter();
    }

    ngOnInit(): void {
        this.loadDataSource();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('history')) {
            this.loadDataSource();
        }
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('goal')) {
            this.loadDataSource();
        }
    }

    ngAfterViewInit(): void {
        /** for some reason with ngbModal, the initial transition state isn't being applied.
         * maybe something with the .modal-content parent and how it gets initially positioned by ngbModal.
         * this is a temporary workaround until this is swapped with cmpsDialog */
        timer(100)
            .pipe(
                switchMap(() => {
                    this._transitionSelfStart = true;
                    this._el.nativeElement.parentElement.style.display = 'flex';
                    return timer(100);
                }),
                // eslint-disable-next-line no-return-assign
                tap(() => (this._transitionSelfShow = true)),
            )
            .subscribe();
    }

    loadDataSource(): void {
        this._dataSource = goalHistoryMap(this.history);
    }
}
